var _defs, _path, _g, _g2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrpcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-5.22 -4.97 401.18 171.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.376 56.4 2.534 29.756 29.178 2.913 56.02 29.557z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.419 45.027 86.674 29.4l15.628-15.745 15.745 15.628z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none}.cls-2{fill:#244b5a}.cls-4{fill:#75caca}.cls-5{fill:#74cbca}.cls-6{fill:#73cbca}.cls-7{fill:#72c9c9}.cls-8{fill:#70caca}.cls-9{fill:#6fcac8}.cls-10{fill:#6ec8c8}.cls-11{fill:#6cc9c9}.cls-12{fill:#6dc9c8}.cls-13{fill:#69c7c8}.cls-14{fill:#69c8c7}.cls-15{fill:#68c8c7}.cls-16{fill:#67c7c7}.cls-17{fill:#65c7c7}.cls-18{fill:#64c7c7}.cls-19{fill:#63c6c6}.cls-20{fill:#60c6c6}.cls-21{fill:#60c6c5}.cls-22{fill:#5fc6c5}.cls-23{fill:#5cc5c4}.cls-24{fill:#5ac5c4}.cls-25{fill:#57c4c4}.cls-26{fill:#58c4c3}.cls-27{fill:#55c4c3}.cls-28{fill:#53c3c2}.cls-29{fill:#52c3c2}.cls-30{fill:#50c3c2}.cls-31{fill:#50c1c0}.cls-34{fill:#47c1be}.cls-35{fill:#46c0be}.cls-36{fill:#43c0be}.cls-37{fill:#40bfbd}.cls-38{fill:#3bbfbd}.cls-39{fill:#39bfbc}.cls-40{fill:#34bebd}.cls-41{fill:#32bebb}.cls-42{fill:#2dbdbb}.cls-43{fill:#24bcbb}.cls-44{fill:#21bcb9}.cls-45{fill:#18bbb9}.cls-47{fill:#03bbb8}.cls-48{fill:#06b8b6}.cls-49{fill:#03b7b5}.cls-50{fill:#04b7b4}.cls-51{fill:#00b6b5}.cls-52{fill:#03b6b4}.cls-53{fill:#05b6b2}.cls-54{fill:#01b5b1}.cls-55{fill:#00b4b1}.cls-56{fill:#00b3b0}.cls-62{fill:#00afac}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.253 138.483a30.3 30.3 0 0 0 10.868 8.998 32.6 32.6 0 0 0 14.9 3.382 32 32 0 0 0 12.236-2.087 21.24 21.24 0 0 0 8.133-5.686 21.9 21.9 0 0 0 4.463-8.422 37.6 37.6 0 0 0 1.367-10.292v-12.092h-.287a25.96 25.96 0 0 1-11.23 9.789 34.6 34.6 0 0 1-13.963 2.879 36.3 36.3 0 0 1-13.747-2.591 35 35 0 0 1-11.157-7.126 32.8 32.8 0 0 1-7.486-10.87 34.1 34.1 0 0 1-2.735-13.675 35.8 35.8 0 0 1 2.592-13.676 35.2 35.2 0 0 1 7.125-11.084 32.1 32.1 0 0 1 10.797-7.414 34.8 34.8 0 0 1 13.748-2.663 38.4 38.4 0 0 1 6.405.575 30.3 30.3 0 0 1 6.766 2.016A31.17 31.17 0 0 1 96.933 68.81h.287V57.58h9.502v66.796a54.2 54.2 0 0 1-1.368 11.66 28.8 28.8 0 0 1-5.326 11.372 30.3 30.3 0 0 1-11.013 8.639Q81.96 159.5 70.588 159.5a46.3 46.3 0 0 1-17.994-3.31A41.8 41.8 0 0 1 38.2 145.97zm1.727-48.08a25.8 25.8 0 0 0 1.944 10.004 26.3 26.3 0 0 0 5.325 8.205 25.8 25.8 0 0 0 7.918 5.615 23.3 23.3 0 0 0 9.861 2.087 26.4 26.4 0 0 0 18.138-7.125 22.9 22.9 0 0 0 5.543-8.135 26.2 26.2 0 0 0 1.8-10.651 28.7 28.7 0 0 0-1.728-10.006 24 24 0 0 0-5.039-8.205 24.35 24.35 0 0 0-8.061-5.614 26.2 26.2 0 0 0-10.653-2.088 23.3 23.3 0 0 0-9.861 2.088 25.8 25.8 0 0 0-7.918 5.614 26.3 26.3 0 0 0-5.326 8.205 25.8 25.8 0 0 0-1.943 10.006m98.464 34.549H135.08V23.03h31.382q15.547 0 24.544 6.766 8.996 6.768 8.998 20.442a25.47 25.47 0 0 1-6.694 17.922q-6.695 7.271-19.362 8.421l29.367 48.37h-12.669L162.72 77.59h-17.275zm0-56.863h18.427a41.4 41.4 0 0 0 11.732-1.44 21.8 21.8 0 0 0 7.702-3.814 13.9 13.9 0 0 0 4.174-5.614 18.6 18.6 0 0 0 1.296-6.983 18.3 18.3 0 0 0-1.296-6.837 14.5 14.5 0 0 0-4.174-5.687 20.4 20.4 0 0 0-7.702-3.815 43.6 43.6 0 0 0-11.732-1.367h-18.427zm75.719-45.059h29.656q15.546 0 24.543 6.767t8.998 20.442q0 13.678-8.998 20.513-8.997 6.839-24.543 6.838h-19.29v47.362h-10.366zm10.367 45.06h16.699a41.4 41.4 0 0 0 11.732-1.44 21.8 21.8 0 0 0 7.702-3.814 13.94 13.94 0 0 0 4.174-5.614 18.6 18.6 0 0 0 1.296-6.983 18.2 18.2 0 0 0-1.296-6.837 14.5 14.5 0 0 0-4.174-5.687 20.4 20.4 0 0 0-7.702-3.815 43.6 43.6 0 0 0-11.732-1.367h-16.7zm156.907 40.739a39.5 39.5 0 0 1-6.404 7.342 40.5 40.5 0 0 1-8.71 5.973 49.7 49.7 0 0 1-10.58 3.96 49 49 0 0 1-12.022 1.439 54.5 54.5 0 0 1-21.088-4.03 50.6 50.6 0 0 1-28-28.072 55.8 55.8 0 0 1-4.03-21.45 55.8 55.8 0 0 1 4.03-21.45 50.59 50.59 0 0 1 28-28.07 54.5 54.5 0 0 1 21.088-4.031 51.5 51.5 0 0 1 19.003 3.742 38.33 38.33 0 0 1 16.266 12.381l-9.068 6.766a24.8 24.8 0 0 0-4.32-4.895 31.5 31.5 0 0 0-6.26-4.318 39 39 0 0 0-7.559-3.023 29.2 29.2 0 0 0-8.062-1.152 41.35 41.35 0 0 0-17.562 3.599 39.9 39.9 0 0 0-13.171 9.644 42.4 42.4 0 0 0-8.279 14.037 50.3 50.3 0 0 0 0 33.54 42.4 42.4 0 0 0 8.279 14.036 39.8 39.8 0 0 0 13.171 9.645 41.3 41.3 0 0 0 17.562 3.6 44.5 44.5 0 0 0 7.99-.72 33.2 33.2 0 0 0 7.774-2.447 29.4 29.4 0 0 0 7.198-4.68 34.7 34.7 0 0 0 6.261-7.412z",
    className: "cls-2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.006 2.913-.473 4.188V2.913z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.632 2.913-1.099 9.722V7.101l.473-4.188z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.257 2.913 2.533 18.168v-5.533l1.099-9.722z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.882 2.913 2.533 23.702v-5.534L4.257 2.913z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.507 2.913 2.533 29.236v-5.534L4.882 2.913z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.133 2.913-3.6 31.857v-5.534L5.507 2.913zm.625 0-4.225 37.39V34.77l3.6-31.857z",
    className: "cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.383 2.913-4.85 42.924v-5.534l4.225-37.39z",
    className: "cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.008 2.913 2.533 51.371v-5.534l4.85-42.924z",
    className: "cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.634 2.913-6.04 53.454-.061-.007v-4.989L8.008 2.913z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.259 2.913 3.215 56.4h-.331l-.29-.033 6.04-53.454z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.884 2.913 3.841 56.4h-.626L9.259 2.913z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.51 2.913 4.466 56.4h-.625L9.884 2.913z",
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.135 2.913 5.091 56.4h-.625L10.51 2.913z",
    className: "cls-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.76 2.913 5.717 56.4h-.626l6.044-53.487z",
    className: "cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.385 2.913 6.342 56.4h-.625L11.76 2.913z",
    className: "cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.011 2.913 6.967 56.4h-.625l6.043-53.487z",
    className: "cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.636 2.913 7.592 56.4h-.625l6.044-53.487z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.261 2.913 8.218 56.4h-.626l6.044-53.487z",
    className: "cls-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.886 2.913 8.843 56.4h-.625l6.043-53.487z",
    className: "cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.512 2.913 9.468 56.4h-.625l6.043-53.487z",
    className: "cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.137 2.913 10.093 56.4h-.625l6.044-53.487z",
    className: "cls-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.762 2.913 10.719 56.4h-.626l6.044-53.487z",
    className: "cls-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.387 2.913 11.344 56.4h-.625l6.043-53.487z",
    className: "cls-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.013 2.913 11.969 56.4h-.625l6.043-53.487z",
    className: "cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.638 2.913 12.594 56.4h-.625l6.044-53.487z",
    className: "cls-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.263 2.913 13.22 56.4h-.626l6.044-53.487z",
    className: "cls-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.888 2.913 13.845 56.4h-.625l6.043-53.487z",
    className: "cls-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.514 2.913 14.47 56.4h-.625l6.043-53.487z",
    className: "cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.139 2.913 15.095 56.4h-.625l6.044-53.487z",
    className: "cls-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.764 2.913 15.721 56.4h-.626l6.044-53.487z",
    className: "cls-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.389 2.913 16.346 56.4h-.625l6.043-53.487z",
    className: "cls-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.015 2.913 16.971 56.4h-.625l6.043-53.487z",
    className: "cls-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.64 2.913 17.596 56.4h-.625l6.044-53.487z",
    className: "cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.265 2.913 18.222 56.4h-.626L23.64 2.913z",
    className: "cls-31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4bc2c0",
    d: "M24.891 2.913 18.847 56.4h-.625l6.043-53.487z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4cc1c0",
    d: "M25.516 2.913 19.472 56.4h-.625l6.044-53.487z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.141 2.913 20.097 56.4h-.625l6.044-53.487z",
    className: "cls-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.766 2.913 20.723 56.4h-.626l6.044-53.487z",
    className: "cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.392 2.913 21.348 56.4h-.625l6.043-53.487z",
    className: "cls-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.017 2.913 21.973 56.4h-.625l6.044-53.487z",
    className: "cls-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.642 2.913 22.599 56.4h-.626l6.044-53.487z",
    className: "cls-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.267 2.913 23.224 56.4h-.625l6.043-53.487z",
    className: "cls-39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.893 2.913 23.849 56.4h-.625l6.043-53.487z",
    className: "cls-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.518 2.913 24.474 56.4h-.625l6.044-53.487z",
    className: "cls-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.143 2.913 25.1 56.4h-.626l6.044-53.487z",
    className: "cls-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.768 2.913 25.725 56.4H25.1l6.043-53.487z",
    className: "cls-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.394 2.913 26.35 56.4h-.625l6.043-53.487z",
    className: "cls-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.019 2.913 26.975 56.4h-.625l6.044-53.487z",
    className: "cls-45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0fbab9",
    d: "M33.644 2.913 27.601 56.4h-.626l6.044-53.487z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.269 2.913 28.226 56.4h-.625l6.043-53.487z",
    className: "cls-47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.895 2.913 28.851 56.4h-.625l6.043-53.487z",
    className: "cls-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.52 2.913 29.476 56.4h-.625l6.044-53.487z",
    className: "cls-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.145 2.913 30.102 56.4h-.626L35.52 2.913z",
    className: "cls-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.77 2.913 30.727 56.4h-.625l6.043-53.487z",
    className: "cls-50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.396 2.913 31.352 56.4h-.625L36.77 2.913z",
    className: "cls-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.021 2.913 31.977 56.4h-.625l6.044-53.487z",
    className: "cls-52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.646 2.913 32.603 56.4h-.626l6.044-53.487z",
    className: "cls-53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.271 2.913 33.228 56.4h-.625l6.043-53.487z",
    className: "cls-54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.897 2.913 33.853 56.4h-.625l6.043-53.487z",
    className: "cls-54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.522 2.913 34.478 56.4h-.625l6.044-53.487z",
    className: "cls-55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.147 2.913 35.104 56.4h-.626l6.044-53.487z",
    className: "cls-56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.773 2.913 35.729 56.4h-.625l6.043-53.487z",
    className: "cls-56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b2af",
    d: "M42.398 2.913 36.354 56.4h-.625l6.044-53.487z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b2ae",
    d: "M43.023 2.913 36.979 56.4h-.625l6.044-53.487z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b1ae",
    d: "M43.648 2.913 37.605 56.4h-.626l6.044-53.487z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b1ad",
    d: "M44.274 2.913 38.23 56.4h-.625l6.043-53.487z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b0ac",
    d: "M44.899 2.913 38.855 56.4h-.625l6.044-53.487z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.524 2.913 39.481 56.4h-.626l6.044-53.487z",
    className: "cls-62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.67 2.913.35.039V56.4H39.481l6.043-53.487z",
    className: "cls-62"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m118.046 22.817-.427-9.164h.427z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.046 32.446-.875-18.793h.448l.427 9.164z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.046 42.075-1.324-28.422h.449l.875 18.793z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.735 45.027-1.461-31.374h.448l1.324 28.422v2.952z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.286 45.027-1.461-31.374h.449l1.461 31.374zm-.448 0-1.461-31.374h.448l1.461 31.374z",
    className: "cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.389 45.027-1.461-31.374h.449l1.461 31.374z",
    className: "cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.941 45.027-1.461-31.374h.448l1.461 31.374z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.493 45.027-1.462-31.374h.449l1.461 31.374z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.044 45.027-1.461-31.374h.448l1.462 31.374z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.596 45.027-1.462-31.374h.449l1.461 31.374z",
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.147 45.027-1.461-31.374h.448l1.462 31.374z",
    className: "cls-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.699 45.027-1.462-31.374h.449l1.461 31.374z",
    className: "cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.25 45.027-1.461-31.374h.448l1.462 31.374z",
    className: "cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.802 45.027-1.462-31.374h.449l1.461 31.374z",
    className: "cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.353 45.027-1.461-31.374h.448l1.462 31.374z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.905 45.027-1.462-31.374h.449l1.461 31.374z",
    className: "cls-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.456 45.027-1.461-31.374h.448l1.462 31.374z",
    className: "cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.008 45.027-1.461-31.374h.448l1.461 31.374z",
    className: "cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.559 45.027-1.461-31.374h.449l1.461 31.374z",
    className: "cls-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.111 45.027-1.461-31.374h.448l1.461 31.374z",
    className: "cls-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.662 45.027-1.461-31.374h.449l1.461 31.374z",
    className: "cls-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.214 45.027-1.461-31.374h.448l1.461 31.374z",
    className: "cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.765 45.027-1.461-31.374h.449l1.461 31.374z",
    className: "cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.317 45.027-1.461-31.374h.448l1.461 31.374z",
    className: "cls-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.868 45.027-1.461-31.374h.449l1.461 31.374z",
    className: "cls-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.42 45.027-1.461-31.374h.448l1.461 31.374z",
    className: "cls-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.972 45.027-1.462-31.374h.449l1.461 31.374z",
    className: "cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.523 45.027-1.461-31.374h.448l1.462 31.374z",
    className: "cls-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.075 45.027-1.462-31.374h.449l1.461 31.374z",
    className: "cls-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.626 45.027-1.461-31.374h.448l1.462 31.374zm-.448 0-1.462-31.374h.449l1.461 31.374z",
    className: "cls-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.729 45.027-1.461-31.374h.448l1.462 31.374z",
    className: "cls-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.281 45.027-1.462-31.374h.449l1.461 31.374z",
    className: "cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.832 45.027-1.461-31.374h.448l1.462 31.374z",
    className: "cls-31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4dc2c1",
    d: "m103.384 45.027-1.462-31.374h.449l1.461 31.374z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4cc2c0",
    d: "m102.935 45.027-1.461-31.374h.448l1.462 31.374z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4bc0bf",
    d: "m102.487 45.027-1.461-31.374h.448l1.461 31.374z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.038 45.027-1.461-31.374h.449l1.461 31.374z",
    className: "cls-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.59 45.027-1.461-31.374h.448l1.461 31.374z",
    className: "cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.141 45.027 99.68 13.653h.449l1.461 31.374z",
    className: "cls-36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41c0be",
    d: "m100.693 45.027-1.461-31.374h.448l1.461 31.374z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.244 45.027-1.461-31.374h.449l1.461 31.374z",
    className: "cls-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.796 45.027-1.461-31.374h.448l1.461 31.374z",
    className: "cls-38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3cbfbc",
    d: "m99.347 45.027-1.461-31.374h.449l1.461 31.374z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.899 45.027-1.461-31.374h.448l1.461 31.374z",
    className: "cls-39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.45 45.027-1.461-31.374h.449l1.461 31.374z",
    className: "cls-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.002 45.027-1.461-31.374h.448l1.461 31.374z",
    className: "cls-41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2fbebc",
    d: "m97.554 45.027-1.462-31.374h.449l1.461 31.374z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.105 45.027-1.461-31.374h.448l1.462 31.374z",
    className: "cls-42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2bbdba",
    d: "m96.657 45.027-1.462-31.374h.449l1.461 31.374z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.208 45.027-1.461-31.374h.448l1.462 31.374z",
    className: "cls-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.76 45.027-1.462-31.374h.449l1.461 31.374z",
    className: "cls-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.311 45.027 93.85 13.653h.448l1.462 31.374z",
    className: "cls-45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#16bab9",
    d: "m94.863 45.027-1.462-31.374h.449l1.461 31.374z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#11bab7",
    d: "m94.414 45.027-1.461-31.374h.448l1.462 31.374z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.966 45.027-1.462-31.374h.449l1.461 31.374z",
    className: "cls-47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.517 45.027-1.461-31.374h.448l1.462 31.374z",
    className: "cls-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.069 45.027-1.461-31.374h.448l1.461 31.374z",
    className: "cls-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.62 45.027-1.461-31.374h.449l1.461 31.374z",
    className: "cls-48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b7b6",
    d: "m92.172 45.027-1.461-31.374h.448l1.461 31.374z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.723 45.027-1.461-31.374h.449l1.461 31.374z",
    className: "cls-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.275 45.027-1.461-31.374h.448l1.461 31.374z",
    className: "cls-50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.826 45.027-1.461-31.374h.449l1.461 31.374z",
    className: "cls-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.378 45.027-1.461-31.374h.448l1.461 31.374z",
    className: "cls-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.929 45.027-1.461-31.374h.449l1.461 31.374z",
    className: "cls-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.481 45.027 88.02 13.653h.448l1.461 31.374zm-.448 0-1.462-31.374h.449l1.461 31.374z",
    className: "cls-52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.584 45.027-1.461-31.374h.448l1.462 31.374z",
    className: "cls-53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.136 45.027-1.462-31.374h.449l1.461 31.374z",
    className: "cls-54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.687 45.027-1.014-21.783v-9.591h.001l1.462 31.374zm-.448 0-.566-12.154v-9.629l1.014 21.783z",
    className: "cls-54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.79 45.027-.117-2.525v-9.629l.566 12.154z",
    className: "cls-55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.673 42.502.117 2.525h-.117z",
    className: "cls-55"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.353 13.486 14.218 29.742l16.255 16.135 13.752-.051-14.421-14.305 71.209-.264-6.241 6.283 6.876-.025 8.068-8.128-8.128-8.067-6.876.025L101 27.583l-71.209.264 14.313-14.412z",
    className: "cls-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrpcLogo);
export default __webpack_public_path__ + "static/media/grpc-logo.cef380e79f2b99b497576283249fc188.svg";
export { ForwardRef as ReactComponent };